import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { loadUserFromStorage } from '../../redux/actions/authActions';
import packageService from '../../services/packageService';

export const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.auth?.user);
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const [hasPackage, setHasPackage] = useState(true);

  useEffect(() => {
    dispatch(loadUserFromStorage());
  }, [dispatch]);

  // const getPackage = async () => {
  //   try {
     
  //     const response = await packageService.userPackageControl(authUserId);
  //     if(response.data.data.length == 0){
  //       setHasPackage(false);
  //     }
  //     else{
  //       setHasPackage(true);
  //     }
   
  //   } catch (error) {
  //     setHasPackage(true);
  //   } 
  // };

  // useEffect(() => {
  //   if (authUserId) {
  //     getPackage();
  //   }
  // }, [authUserId, location.pathname]);

  if (!user) {
    return <Navigate to="/auth" replace />;
  }
  if (!hasPackage && location.pathname !== '/NoSubscription' &&  !location.pathname.startsWith('/payment') && !location.pathname.startsWith('/paymentStatus')) {
    return <Navigate to="/NoSubscription" replace />;
  }

  return children;
};